// @ts-nocheck

import React, { useCallback, useState, useEffect, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { ReactComponent as ChevronLeft } from '../../../../assets/svg/chevron-left.svg';
import { ReactComponent as ChevronRight } from '../../../../assets/svg/chevron-right.svg';
import Swipe from '../../../../components/Swipe';
import { __ } from '../../../../i18n/l10n';
import MovingRepereMenu from '../buttons/MovingRepereMenu';
import Grid from '../grid/GridsGrid';

import SwipeReperes from './SwipeReperes';

const StyledMenuModeSystemGrid = styled(MovingRepereMenu)`
  margin: 1em 0;
`;

const WrapSwipe = styled.div`
  position: relative;
`;

const StyledSwipe = styled(Swipe)`
  & > div {
    padding: 1em 0;
  }
`;

const commonArrow = css`
  position: absolute;
  top: calc(50% - 1em);
  width: auto;
  height: 1.5em;
  z-index: 1;
  padding: 0 1em;
`;

const ArrowLeft = styled(ChevronLeft)`
  ${commonArrow}
  left: -1.7em;
`;

const ArrowRight = styled(ChevronRight)`
  ${commonArrow}
  right: -1.7em;
`;

const SystemViewModes = {
  COMPACT: 'COMPACT',
  DETAILED: 'DETAILED',
};

type GridsBasketGridProps = {
  matches: Array<number>;
  selections: Array<string>;
  isSystem: boolean;
};

const GridsBasketGrid = ({ matches, selections, isSystem }: GridsBasketGridProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [systemViewMode, setSystemViewMode] = useState(SystemViewModes.COMPACT);
  const isSystemCompactView = useMemo(() => currentIndex === 0 && isSystem, [isSystem, currentIndex]);

  const goNext = useCallback(() => {
    setCurrentIndex((old) => {
      if (old < selections.length - 1) {
        return old + 1;
      }
      return old;
    });
  }, [selections.length]);

  const goPrevious = useCallback(() => {
    setCurrentIndex((old) => {
      if (old > 0) {
        return old - 1;
      }
      return old;
    });
  }, []);

  const changeSystemViewMode = useCallback(
    (mode) => {
      setSystemViewMode(mode);
    },
    [setSystemViewMode],
  );

  useEffect(() => {
    setCurrentIndex(systemViewMode === SystemViewModes.COMPACT ? 0 : 1);
  }, [systemViewMode]);

  useEffect(() => {
    setSystemViewMode(isSystemCompactView ? SystemViewModes.COMPACT : SystemViewModes.DETAILED);
  }, [isSystemCompactView]);

  // # RM #134939
  if (isSystem && selections.length > 100) {
    return (
      <>
        <StyledMenuModeSystemGrid
          items={[{ label: __('Compact grid'), id: SystemViewModes.COMPACT }]}
          selectedId={SystemViewModes.COMPACT}
        />
        <Grid matches={matches} selection={selections[0]} isBasket isSystemCompact />
      </>
    );
  }

  return isSystem ? (
    <>
      <StyledMenuModeSystemGrid
        items={[
          { label: __('Compact grid'), id: SystemViewModes.COMPACT },
          { label: __('Detailed grids'), id: SystemViewModes.DETAILED },
        ]}
        selectedId={systemViewMode}
        onClick={changeSystemViewMode}
      />
      <WrapSwipe>
        {currentIndex > 0 && <ArrowLeft onClick={goPrevious} />}
        {currentIndex < selections.length - 1 && <ArrowRight onClick={goNext} />}
        <StyledSwipe setIndex={setCurrentIndex} indexToGo={currentIndex} noScale>
          {selections.map((selection, index) => (
            <div key={`${selection}-${index}`}>
              <Grid matches={matches} selection={selection} isBasket isSystemCompact={index === 0} />
            </div>
          ))}
        </StyledSwipe>
      </WrapSwipe>
      <SwipeReperes current={currentIndex} length={selections.length} />
    </>
  ) : (
    <Grid matches={matches} selection={selections[0]} isBasket />
  );
};

export default GridsBasketGrid;
